import React from 'react'
import { AlignType } from './types/stylesTypes'

type ImagePropsType = {
  src: string
  width?: number
  align: AlignType
  url?: string
}

function Image(props: ImagePropsType) {
  const link = (
    <img
      src={props.src}
      alt=""
      width={props.width}
      style={{
        display: 'block',
        maxWidth: props.width,
        width: '100%',
      }}
    />
  )

  return (
    <table cellPadding="0" cellSpacing="0" align={props.align} style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td style={{ width: props.width }} align={props.align}>
            {props.url ? <a href={props.url}>{link}</a> : link}
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Image
